module.exports = __webpack_public_path__ + "static/media/blueWave.64e1d6cf.jpg";